<footer  class="bg-dark navbar-dark">
    <p class="navbar-brand text-xs-center">© Copyright 2020. All rights reserved.</p>
</footer>